import { createSlice } from "@reduxjs/toolkit";

export const detailSlice = createSlice({
    name: 'detail',
    initialState: {
        previous: null
    },
    reducers: {
		setState: (state, { payload }) => {
			state.previous = payload;
		},
		resetState: (state, props) => {
			state.previous = null;
		}
	}
})

export const { setState, resetState } = detailSlice.actions;
export default detailSlice.reducer;
